import React from 'react';

export class FormArea extends React.Component {

    render() {
        const {
            col,
            rows,
            icon,
            disabled,
            placeholder,
            label,
            resize = 'none',
            input: {
                value, // IMPORTANTE: si no se inicializa con un valor por defecto puede tomarlo como uncontrolled cuando redux-form envíe un undefined/null
                onBlur,
            },
            meta: {
                touched,
                submitFailed,
                error,
            },
            classFormGroup,
            classTextArea,
        } = this.props;

        return (
            <div className={col}>
                <div className={`form-group ${classFormGroup}`}>
                    <div className={`form-line ${touched && error ? 'focused error' : ''}`}>
                        <div className="form-label-icon">
                            <label>{label}</label>
                            {icon}
                        </div>
                        <textarea
                            rows={rows}
                            value={value}
                            className={`form-control ${classTextArea}`}
                            disabled={disabled}
                            placeholder={placeholder}
                            onChange={this.handleOnChange}
                            onBlur={() => onBlur(undefined)}
                            style={{resize}}
                        />
                    </div>
                    <label className="error">
                        {
                            submitFailed && touched ? error : ''
                        }
                    </label>
                </div>
            </div>
        );
    }

    handleOnChange = (value) => {
        const {input} = this.props;
        input.onChange(value);
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/components/FormArea.js